<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
</div>

<div class="modal-body">
  <p [innerHtml]="message" [ngClass]="{ 'text-danger': isError }"></p>
</div>

<div class="modal-footer">
  <button type="button"
          class="btn btn-warning"
          data-test="Ok"
          (click)="activeModal.close('ok')">
    OK
  </button>
</div>
